interface BackgroundChipProps {
  name: string;
  status?: 'ok' | 'amber' | 'red';
}

const STATUS_COLOR: Record<NonNullable<BackgroundChipProps['status']>, string> = {
  ok: 'var(--olive)',
  amber: 'var(--gold)',
  red: 'var(--red)',
};

export default function BackgroundChip({ name, status = 'ok' }: BackgroundChipProps) {
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '5px 10px',
        background: 'var(--panel2)',
        border: '1px solid var(--line)',
        borderRadius: 999,
        fontSize: 12,
        color: 'var(--muted)',
      }}
      title={`Background scanner · ${status}`}
    >
      <span style={{ width: 7, height: 7, borderRadius: '50%', background: STATUS_COLOR[status], boxShadow: `0 0 6px ${STATUS_COLOR[status]}` }} />
      {name}
    </span>
  );
}
